export default {
    url: 'collections/solar-generators',
    include: ['us'],
}